import { useEffect, useState } from "react";

export const useNow = (ms = 1000) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), ms);
    return () => clearInterval(t);
  }, [ms]);

  return now;
};

/**
 * Format UTC ISO/date ke timezone perangkat/browser.
 * Backend tetap menyimpan UTC.
 */
export const fmtClock = (d) => {
  const date = d instanceof Date ? d : new Date(d);

  if (Number.isNaN(date.getTime())) return "—";

  return new Intl.DateTimeFormat("id-ID", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZoneName: "short",
  }).format(date);
};

/**
 * Format timestamp menjadi tanggal + jam lokal perangkat.
 */
export const fmtDateTime = (value, options = {}) => {
  if (!value) return "—";

  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) return "—";

  return new Intl.DateTimeFormat("id-ID", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    ...options,
  }).format(date);
};

/**
 * Format tanggal lokal untuk kebutuhan filter <input type="date">.
 * Sengaja menggunakan timezone perangkat, bukan UTC.
 */
export const localDateKey = (value) => {
  if (!value) return "";

  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  const parts = new Intl.DateTimeFormat("en-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);

  const get = (type) => parts.find((p) => p.type === type)?.value;

  return `${get("year")}-${get("month")}-${get("day")}`;
};

/**
 * Format jam lokal HH:MM:SS.
 */
export const localTimeKey = (value) => {
  if (!value) return "";

  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  return new Intl.DateTimeFormat("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(date);
};

export const sessionOf = (d) => {
  const h = d.getUTCHours();

  if (h >= 7 && h < 12) return "London";
  if (h >= 12 && h < 16) return "Overlap LD/NY";
  if (h >= 16 && h < 21) return "New York";

  return "Asia";
};

export const nextCandleSecs = (d, mins = 15) => {
  const s = Math.floor(d.getTime() / 1000);
  const period = mins * 60;

  return period - (s % period);
};

export const fmtDur = (secs) => {
  const p = (n) => String(n).padStart(2, "0");

  return `00:${p(Math.floor(secs / 60))}:${p(secs % 60)}`;
};

export const biasCls = (b) =>
  b === "Bullish"
    ? "text-buy"
    : b === "Bearish"
      ? "text-sell"
      : "text-warn";

export const alertChip = (a) =>
  a === "VALID SETUP"
    ? "bg-buy/15 text-buy border-buy/40"
    : a === "WATCH"
      ? "bg-warn/10 text-warn border-warn/40"
      : a === "INVALIDATED"
        ? "bg-sell/10 text-sell border-sell/40"
        : "bg-white/5 text-mute-dim border-white/10";

export const kindChip = (k) =>
  ({
    valid: "bg-buy/15 text-buy border-buy/40",
    sweep: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
    mss: "bg-brand/15 text-[#8b97f5] border-brand/40",
    displacement: "bg-warn/10 text-warn border-warn/40",
    invalidated: "bg-sell/10 text-sell border-sell/40",
  }[k] || "bg-white/5 text-mute border-white/10");
